import { BaseLink } from "@clipboard-health/ui-react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { type ReactElement } from "react";

import { DeprecatedGlobalAppV1Paths } from "../App/paths";
import { AppBarHeader, PageWithHeader } from "../lib";
import { APP_V2_USER_EVENTS } from "../lib/analytics";
import { useLogEffect } from "../lib/analytics/useLogEffect";
import { WorkerAvailabilityCriteria } from "./components/WorkerAvailabilityCriteria/WorkerAvailabilityCriteria";

export function AvailabilityCriteriaPage(): ReactElement {
  useLogEffect(APP_V2_USER_EVENTS.AVAILABILITY_CRITERIA_VIEWED);

  return (
    <PageWithHeader
      appBarHeader={
        <AppBarHeader
          title="My Criteria"
          leftCta={
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="Close"
              title="Close"
              component={BaseLink}
              to={DeprecatedGlobalAppV1Paths.OPEN_SHIFTS}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          }
        />
      }
    >
      <WorkerAvailabilityCriteria />
    </PageWithHeader>
  );
}
